<template>
    <div class="tab-div">
        <el-row>
            <el-button v-for="item in tabArr" :round="item.round === true ? true : false"
                :size="item.size ? item.size : 'medium'"
                :class="{ 'el-button--primary': isPrimary[item.name] === true }" @click="handleChoose(item)"
                :key="item.name">
                {{ item.name }}
            </el-button>
            <div style="text-align: center;display: inline-block;margin-left: 0.2rem;">
                <el-date-picker size="medium" v-model="date" type="datetimerange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']" @change="handleSearch">
                </el-date-picker>
            </div>
        </el-row>
        <slot></slot>
    </div>
</template>

<script>
import { fscDate } from '../../static/mixins/fastChooseDate'

export default {
    name: 'TabWithDateTimeRange',
    props: {
        tabArr: {
            type: [Array]
        }
    },
    mixins: [fscDate],
    data() {
        return {
            isPrimary: [],
            date: '',
            choosedName: ''
        }
    },
    watch: {
        tabArr: {
            handler() {
                this.tabArr.map(item => {
                    if (item.selected === true) {
                        this.isPrimary = []
                        this.isPrimary.push(item.name)
                        this.isPrimary[item.name] = true
                    }
                })
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        handleChoose(item) {
            this.isPrimary = []
            this.isPrimary.push(item.name)
            this.isPrimary[item.name] = true
            this.date = ''
            this.sendDateToF({name: item.name})
        },
        handleSearch(val) {
            if (val) {
                this.isPrimary = []
                this.sendDateToF({date: this.date})
            }
        },
        sendDateToF(data) {
            this.$emit('choosed', data)
        }
    },
    mounted() {
        console.log(this.tabArr)
    }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/commonReform/TabDiv.vue